<template>
  <div class="ui-field">
    <div class="ui-field_header">
      <span class="ui-field_label">{{label}}</span>

      <slot name="headerAppend"></slot>
    </div>


    <div class="ui-field_control">
      <slot>

      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ui-field',

  props: {
    label: {
      type: String,
    }
  },


}
</script>

<style  lang="sass">
.ui-field_label
  font-weight: 300
  color: #8A8A8A

.ui-field_header
  display: flex
  // flex-wrap: wrap
  width: 100%
</style>
